export const DELIVERY_MODULE = 'DELIVERY'

export const businessScopeConfig = [
	{ businessScope: 'DELIVERY', title: 'Settings.delivery' },
	{ businessScope: 'PICKUP', title: 'Settings.pickup' },
	{ businessScope: 'COUNTER', title: 'Settings.counter' },
]
